import { Component, OnInit, OnDestroy } from '@angular/core';
import { select } from '@ptl/angular-redux-store';
import { DRXMonthlyCosts, DRXRetailAndMailCosts } from 'src/app/shared/interfaces/drx.interface';
import { Observable } from 'rxjs';
import { DRUG_TOGGLE_OPTIONS } from 'src/app/shared/enums/drug-costs.enum';

@Component({
    selector: 'app-yearly-drug-costs-table',
    templateUrl: './yearly-drug-costs-table.component.html',
    styleUrls: ['./yearly-drug-costs-table.component.scss'],
    standalone: false
})
export class YearlyDrugCostsTableComponent implements OnInit, OnDestroy {

  @select(['componentStates', 'DrxServiceData', 'drxToggleOption']) retailMailOrderSwitch$: Observable<DRUG_TOGGLE_OPTIONS>;
  retailMailOrderSwitch: DRUG_TOGGLE_OPTIONS;

  monthLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'Total'];

  @select(['componentStates', 'DrxServiceData', 'drxMonthlyCosts', 'retail']) retail$: Observable<DRXMonthlyCosts>;
  @select(['componentStates', 'DrxServiceData', 'drxMonthlyCosts', 'mailOrder']) mailOrder$: Observable<DRXMonthlyCosts>;
  tableData: DRXRetailAndMailCosts = {
    retail: null,
    mailOrder: null
  };

  constructor() {
    this.retail$.subscribe((val) => {
      this.tableData.retail = val;
    });

    this.mailOrder$.subscribe((val) => {
      this.tableData.mailOrder = val;
    });
    
    this.retailMailOrderSwitch$.subscribe( value => this.retailMailOrderSwitch = value);
  }

  async ngOnInit() {
    
  }

  ngOnDestroy() {
  }
}
